import { matcher, EntityKind } from "../entityKinds";
import { Dir } from "../../entities/Player";

export namespace RulesPush {
  // TODO: Fill in generic, simple, rules that pattern match entities against one another.
  // This file is for if an entity can overlap another entity.
  // This is only done for linear resolution and not for side effects.
  // Once we want to stamp an entity onto another we call the overlap rules.
  // If this is false then the overlap will never happen because the entity
  // cannot slide onto the tile.
  // An example is the player trying to move onto
  export enum OverlapResolution {
    Stop,
    Push,
    CanMove,
  }
  export const canBePushedOnto = matcher<OverlapResolution>({
    [EntityKind.StaticWall]: () => OverlapResolution.Stop,
    [EntityKind.Crate]: () => OverlapResolution.Push,
    [EntityKind.Empty]: () => OverlapResolution.CanMove,
    // This is to prevent enemies running into the lazor after it happens.
    [EntityKind.PlayerBullet]: () => OverlapResolution.Stop,
    // Would be cool to have an enemy that boxes you in. Tries to get to your side and digs into ground thus cannot be moved.
    [EntityKind.MeleeEnemy]: () => OverlapResolution.Push,
    [EntityKind.PressurePlate]: () => OverlapResolution.CanMove,
    [EntityKind.Door]: (e) =>
      e.isOpen ? OverlapResolution.CanMove : OverlapResolution.Stop,
    [EntityKind.PlayerGun]: () => OverlapResolution.Stop,
    [EntityKind.PlayerBody]: () => OverlapResolution.CanMove,
    [EntityKind.TDamage]: () => OverlapResolution.CanMove,
    [EntityKind.WinLevel]: () => OverlapResolution.CanMove,
    [EntityKind.ExtendedBlock]: () => OverlapResolution.Push,
    [EntityKind.LazorToggle]: () => OverlapResolution.Stop,
  });

  export const pushedSideEffect = (dir: Dir, isDelayed: boolean = false) =>
    matcher<void>({
      [EntityKind.StaticWall]: () => {},
      [EntityKind.Crate]: (e) => e.entity?.().move(dir, isDelayed),
      [EntityKind.ExtendedBlock]: (e) => e.entity?.().move(dir, isDelayed),
      [EntityKind.Empty]: () => {},
      [EntityKind.PlayerBullet]: () => {},
      [EntityKind.MeleeEnemy]: (e) => e.entity?.().move(dir, isDelayed),
      [EntityKind.PressurePlate]: () => {},
      [EntityKind.Door]: () => {},
      [EntityKind.PlayerGun]: () => {},
      [EntityKind.PlayerBody]: () => {},
      [EntityKind.TDamage]: () => {},
      [EntityKind.WinLevel]: () => {},
      [EntityKind.LazorToggle]: () => {},
    });
}
